import { jsx as _jsx } from "react/jsx-runtime";
import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
export const DialogCloseButton = ({ onClick, sx = {}, }) => (_jsx(IconButton, { "aria-label": "close", onClick: onClick, sx: {
        color: (theme) => theme.palette.action.active,
        my: -1,
        alignSelf: 'flex-start',
        ...sx,
    }, children: _jsx(Close, {}) }));
